import { UserTier } from "@/enums/UserTier";
import {
  UserInterface,
  SalesPersonDetailsInterface,
} from "@/types/UserInterface";
import { UserRoles } from "@/enums/UserRoles";
import userApi from "@/services/api/userApi";

export async function hasRequiredTier(
  user: UserInterface,
  requiredTier: UserTier
): Promise<boolean> {
  if (!user.tier) {
    return false;
  }

  const tierHierarchy = {
    [UserTier.OFF]: -1,
    [UserTier.FREE]: 0,
    [UserTier.TIER_1]: 1,
    [UserTier.TIER_2]: 2,
    [UserTier.TIER_3]: 3,
  };

  if (user.role === UserRoles.SALES_PERSON) {
    const salesPersonDetails = user.detailsId as SalesPersonDetailsInterface;

    if (salesPersonDetails?.landownerId) {
      try {
        const response = await userApi.getUser(salesPersonDetails.landownerId);
        const landowner = response.data;

        if (
          landowner?.tier &&
          Object.values(UserTier).includes(landowner.tier as UserTier)
        ) {
          return (
            tierHierarchy[landowner.tier as UserTier] >=
            tierHierarchy[requiredTier]
          );
        }
      } catch (error) {
        console.error("Error fetching landowner tier:", error);
        return false;
      }
    }

    return false;
  }

  return tierHierarchy[user.tier] >= tierHierarchy[requiredTier];
}
